import { useContext } from 'react';
import { VideosContext } from '@shapeable/ui';

export const useHowToVideos = () => useContext(VideosContext).filter(video => video?.type?.slug === 'how-to-guide');